const userTypes = {
  Admin: 'admin',
  Manager: 'manager',
  ExternalUser: 'ext-user'
};

export default userTypes;
